import type { FaireProductEntity } from "../../entity_types/product";

export const p_h2kmzwush4: FaireProductEntity = {
  token: "p_h2kmzwush4",
  type: "product",
  name: "Pine Forest Wax Melt  ",
  brandName: "The Littlest Things",
  imageUrl:
    "https://cdn.faire.com/fastly/8f678743cc25b3b0977c52f6e218ccd9daab756067d1c5e8473a1dcd40de9ed5.png",
  priceDollars: 3.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c69533268d4d56f38375c4baa60ce1c6d10ed00944b7c56ae30417f49c52d352.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
